import React from 'react';

function DefaultSender({ color = '#666666', ...props }) {
    return (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M12 2C17.52 2 22 6.48 22 12C22 12.0843 21.9952 12.1682 21.9932 12.252C20.8604 11.4636 19.4847 11 18 11C16.0983 11 14.3739 11.7585 13.1123 12.9893C12.7054 12.9315 12.3261 12.9004 12 12.9004C10 12.9004 6.03 13.9905 6 15.9805C7.13184 17.6824 8.97211 18.8754 11.0947 19.1426C11.2666 20.1894 11.6702 21.1574 12.252 21.9932C12.1682 21.9952 12.0843 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM12 5C10.34 5 9 6.34 9 8C9 9.66 10.34 11 12 11C13.66 11 15 9.66 15 8C15 6.34 13.66 5 12 5Z"
                fill={color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18 13C15.24 13 13 15.24 13 18C13 20.76 15.24 23 18 23C20.76 23 23 20.76 23 18C23 15.24 20.76 13 18 13ZM17 20.5L14.5 18L15.205 17.295L17 19.085L20.795 15.29L21.5 16L17 20.5Z"
                fill={color}
            />
        </svg>
    );
}

export default DefaultSender;
